module.exports = __webpack_public_path__ + "static/img/one.3307d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinDupLeImg/one.png
// module id = Vmiu
// module chunks = 1